import { useTranslation } from 'react-i18next'
import { DiagnosticsSystem } from './types'

/**
 * Name of the machine a diagnostics message refers to: the bare vehicle ID for the car server, which is what
 * the vehicle ID has always stood for in diagnostics, and an explicit control unit mention otherwise
 */
export const useDiagnosticsTarget = (system: DiagnosticsSystem, source: string) => {
  const { t } = useTranslation('diagnostics')
  return system === 'cu' ? t('controlUnitOf', { source: source.toUpperCase() }) : source.toUpperCase()
}
